<!-- <mwo-smart-grid [hasSettings]="false" class="blacklist">
  <h3 class="blacklist-previous-page" previousPage>{{ "library.title" | translate }}</h3>
  <h2 class="playlist-title" header style="font-size: 20px; margin-top: 0.5rem">Blacklist</h2>
  <h4 class="blacklist-infos" header style="font-size: 20px; margin-top: 0.3rem">{{totalLength + ' ' +
    ('blacklist.songs' | translate) + ' — ' + (totalDuration | duration: 'hh:mm': true) }}</h4>
</mwo-smart-grid>
<button matRipple class="blacklist-restore-all-tracks-button" *ngIf="totalLength !== 0"
  (click)="unblacklistAll()">{{('blacklist.restoreAll' | translate)}}</button>
<div class="blacklist-container">
  <div class="box-music" itemSize="40" style="background: rgb(255 255 255 / 40%);">
    <div *ngFor="let item of (blacklistList$ | async)">
      <mwo-track [item]="item" [mode]="'blacklist'"></mwo-track>
    </div>
  </div>
</div>
 -->

<div class="playlist-container">

  <div class="playerlist-header-container-row">
    <mwo-scheduler [displayFullPage]="false"></mwo-scheduler>
  </div>

  <div class="playlist-main-content">

    <mwo-breadcrumb (click)="back()" title="{{ 'library.title' | translate }}"></mwo-breadcrumb>

    <div class="playlist-col-container">
      <div class="playlist-header-container">
        <div class="playlist-header">
          <div class="header-right-info">
            <div class="title">
              <span class="playlist-title">Blacklist</span>
            </div>
            <div class="playlist-details">
              <div class="playlist-info">
                <mwo-list-counter [count]="totalLength" [message]="'playlistsFamilies.label.tracks'" class="media-data"
                  id="playlist-counter"></mwo-list-counter>
                <!-- <span class="playlist-duration">{{ totalDuration | duration:
                  'hh:mm': true }}</span> -->
              </div>
            </div>
          </div>
          <div class="header-right-play-btn">
            <!--
              Css translate 10 px related in the scss file
            -->
            <button mat-raised-button class="blacklist-restore-all-tracks-button" *ngIf="totalLength !== 0"
              (click)="unblacklistAll()">{{('blacklist.restoreAll' | translate)}}</button>

          </div>
        </div>
      </div>

      <div class="title-tracks">
        <div class="box-music">
          <div class="box-music-content">
            <div *ngFor="let item of (blacklistList$ | async)">
              <mwo-track [item]="item" [mode]="'blacklist'"></mwo-track>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>